import { useEffect, useState } from "react";
import { DeviceMobile, X, ShareNetwork, PlusSquare } from "@phosphor-icons/react";

const DISMISS_KEY = "dojova_install_dismissed_at";
const DAYS = 14;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

// Bandeau « Installer DOJOVA » : 1 clic sur Android/Chrome/Edge (beforeinstallprompt), guide 2 étapes sur iPhone/iPad.
export default function InstallAppBanner({ compact = false, who = "membre" }) {
  const [promptEvt, setPromptEvt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    const dismissed = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (Date.now() - dismissed < DAYS * 86400000) return;
    const onPrompt = (e) => { e.preventDefault(); setPromptEvt(e); setVisible(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) setVisible(true);
    const onInstalled = () => { setVisible(false); localStorage.setItem(DISMISS_KEY, String(Date.now() + 10 * 365 * 86400000)); };
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, String(Date.now())); setVisible(false); };
  const install = async () => {
    if (promptEvt) { promptEvt.prompt(); const r = await promptEvt.userChoice; if (r?.outcome === "accepted") setVisible(false); return; }
    setShowIOS(true);
  };
  if (!visible) return null;

  return (
    <div data-testid="install-app-banner" className={`relative overflow-hidden rounded-2xl border border-amber-500/40 bg-gradient-to-r from-zinc-950 via-zinc-900 to-zinc-950 text-zinc-100 ${compact ? "p-3" : "p-4 md:p-5"} mb-5`}>
      <div className="flex items-center gap-3 md:gap-4">
        <img src="/brand/dojova-icon-192.png" alt="" className={`${compact ? "w-10 h-10" : "w-12 h-12 md:w-14 md:h-14"} rounded-xl shrink-0`} />
        <div className="min-w-0 flex-1">
          <p className={`font-bold leading-tight ${compact ? "text-sm" : "text-base"}`}>Installer DOJOVA sur votre téléphone</p>
          <p className="text-xs text-zinc-400 mt-0.5 truncate">{who === "coach" ? "Présences, horaire et élèves en un tap — même sans réseau stable." : "Carnet, horaire, paiements et annonces — comme une vraie application."}</p>
        </div>
        <button onClick={install} data-testid="install-app-btn" className="inline-flex items-center gap-1.5 rounded-full bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold px-4 py-2 text-sm whitespace-nowrap transition-colors">
          <DeviceMobile size={16} weight="bold" /> Installer
        </button>
        <button onClick={dismiss} aria-label="Plus tard" data-testid="install-app-dismiss" className="text-zinc-500 hover:text-zinc-200 transition-colors"><X size={16} /></button>
      </div>
      {showIOS && (
        <div className="mt-3 rounded-xl bg-zinc-950/80 border border-zinc-800 p-3 text-sm text-zinc-300" data-testid="install-ios-steps">
          <p className="font-semibold text-zinc-100 mb-2">Sur iPhone / iPad (Safari) :</p>
          <ol className="space-y-1.5">
            <li className="flex items-center gap-2"><ShareNetwork size={16} className="text-amber-400" /> 1. Touchez <b>Partager</b> (le carré avec la flèche, en bas).</li>
            <li className="flex items-center gap-2"><PlusSquare size={16} className="text-amber-400" /> 2. Choisissez <b>Sur l'écran d'accueil</b>, puis <b>Ajouter</b>.</li>
          </ol>
        </div>
      )}
    </div>
  );
}
